import * as React from "react"

function IconDrivelines(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      {...props}
    >
      <title>{"Drivelines"}</title>
      <g fill="none" fillRule="evenodd">
        <g stroke="#E3E833" strokeWidth={3}>
          <path d="M18.465 29.787c0-1.835.651-3.52 1.735-4.832M13.436 32.483a7.565 7.565 0 01-2.19-4.644M11.787 37.944a7.564 7.564 0 01-4.832-1.735M14.483 42.973a7.565 7.565 0 01-4.644 2.19M19.944 44.623a7.564 7.564 0 01-1.735 4.832M24.973 41.927a7.565 7.565 0 012.19 4.644M26.623 36.465c1.835 0 3.519.651 4.832 1.735M23.927 31.436a7.565 7.565 0 014.644-2.19" />
        </g>
        <g stroke="#E3E833" strokeWidth={3}>
          <path d="M40.535 15.787a7.564 7.564 0 00-1.735-4.832M45.564 18.483a7.565 7.565 0 002.19-4.644M47.213 23.944a7.564 7.564 0 004.832-1.735M44.517 28.973a7.565 7.565 0 004.644 2.19M39.056 30.623c0 1.835.65 3.519 1.735 4.832M34.027 27.927a7.565 7.565 0 00-2.19 4.644M32.377 22.465a7.564 7.564 0 00-4.832 1.735M35.073 17.436a7.565 7.565 0 00-4.644-2.19" />
        </g>
      </g>
    </svg>
  )
}

export default IconDrivelines
